import { formatDate, Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { IvaTypeEnums } from 'src/app/enum/iva-type-enums';
import { NoteStateEnums } from 'src/app/enum/note-state-enums';
import { NoteTypeEnums } from 'src/app/enum/note-type-enums';
import { TypeConceptEnums } from 'src/app/enum/type-concept-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { NotePrintModel } from 'src/app/models/invoicing/note-print.model';
import { NoteModel } from 'src/app/models/invoicing/note.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { RequestNoteModalModel } from 'src/app/models/tables/invoicing/request-note-modal.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { NoteService } from 'src/app/services/invoicing/note.service';
import { RequestNoteService } from 'src/app/services/invoicing/request-note.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { BussinessDocumentsTypeService } from 'src/app/services/management/bussiness-documents-type.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { DocumentSupportService } from 'src/app/services/shopping/document-support.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { NoteDetailComponent } from 'src/app/views/invoicing/note-detail/note-detail/note-detail.component';

@Component({
  selector: 'app-register-note',
  templateUrl: './register-note.component.html',
  styleUrls: ['./register-note.component.scss'],
  standalone: false
})
export class RegisterNoteComponent implements OnInit {

  @ViewChild('selectRequestNote') selectRequestNoteModalComponent?: CustomModalComponent | null = null;
  @ViewChild('attachFileRequestNote') attachFileRequestNoteComponent?: CustomModalComponent | null = null;
  @ViewChild('noteDetail') noteDetailComponent?: NoteDetailComponent | null = null;

  ascendantRequestNote: boolean = true;
  accountingInterfaceCode: string = '';
  branchId: number = 0;
  bussinessDocumentsClassId: number = BussinessDocumentsClassEnums.notaCredito;
  bussinessDocumentsTypeClass: number = BussinessDocumentsClassEnums.factura;
  bussinessDocumentsTypeInvoiceForm: FormControl = new FormControl(0);
  bussinessDocumentsTypeInvoiceId: number = 0;
  bussinessDocumentsTypeId: number = 0;
  buttonAnnuls: boolean = false;
  classInputClient: string = '';
  classInputCostCenter: string = '';
  classInputStateNote: string = '';
  clientId: number = 0;
  codeCurrency: string = '';
  codeNameClient: string = '';
  codeNameProvider: string = ''
  codeNameCostCenter: string = '';
  columnSortRequestNote: string | null = null;
  companyId: number = 0;
  costCenterId: number | null = null;
  cude: string | null = '';
  dataRequestNotes: PagedResponseModel<RequestNoteModalModel> = new PagedResponseModel<RequestNoteModalModel>();
  dateInvoice: string = '';
  disabledActions: boolean = false;
  disabledSend: boolean = false;
  documentSupportConsecutive: number = 0;
  electronicInvoiceInterfaceCode: string = '';
  enterpriseId: number = 0
  filtersRequestNotes: ColumnResponseModel[] = [];
  finishLoadingPrint: boolean = false;
  formatModel: FormatModel = new FormatModel();
  formNote: FormGroup = new FormGroup({});
  formNoteTotals: FormGroup = new FormGroup({});
  headerChanged: boolean = false;
  headerRequestNotes: ColumnResponseModel[] = [];
  iconStateNote: string = '';
  iconWindow: string = '';
  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: true
  });
  inputsForRequestNoteModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
  });
  invoiceConsecutive: number = 0;
  invoiceId: number = 0;
  invoiceSwIcaSelfRetainer: boolean = false;
  invoiceSwSelfRetainer: boolean = false;
  invoiceStateString: string = '';
  isDocumentSupport: boolean = false;
  isLevelArticle: boolean = false;
  isOpened: string | undefined = undefined;
  limitRequestNote: number = 10;
  listBranches: CustomListDropdown[] = [];
  listBussinessDocumentsTypes: CustomListDropdown[] = [];
  listBussinessDocumentsTypesInvoice: CustomListDropdown[] = [];
  listConcepts: CustomListDropdown[] = [];
  listFiles: any[] = [];
  listEnterprises: any[] = [];
  listNoteTypes: CustomListDropdown[] = [];
  listNoteTypeFiltered: CustomListDropdown[] = [];
  listLevel: CustomListDropdown[] = [
    { label: 'Artículo', value: true },
    { label: 'Concepto', value: false }];
  listOperationsTypeDian: CustomListDropdown[] = [
    { label: '20 - Referencia factura electrónica', value: 20 },
    { label: '22 - Sin referencia a facturas', value: 22 },
    { label: '0 - Referencia factura (No Electrónica)', value: 0 }];
  copyListOperationsTypeDian: CustomListDropdown[] = [];
  mainBranchByUser: BranchModel = new BranchModel();
  messageStateNote: string = '';
  nameWindow: string = '';
  noteContract: NoteModel = new NoteModel();
  noteId: number = 0;
  notePrintModel: NotePrintModel = new NotePrintModel();
  noteTypeId: number = 0;
  noteStateString: string = '';
  output$ = new Subject<any>();
  outputForAttachFiles$ = new Subject<any>();
  pageRequestNote: number = 1;
  permissionUpdatable: boolean = false;
  permissionPrint: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  previousWindow: string = '';
  projectName = ProjectName.projectName;
  providerId: number = 0;
  printNoteFormat: boolean = false;
  quantityDetails: number = 0;
  requestNoteActive: boolean = false;
  requestNoteConsecutive: number | string = '';
  residueValueInvoice: number = 0;
  severityState: string = "danger";
  showAccordion: boolean = false;
  stateClientId: ClientStateEnums.activo;
  stateCostCenterId: number = 0;
  stateOpen: number = NoteStateEnums.open;
  subscription: Subscription;
  subscriptionAttach: Subscription;
  swElectronicInvoice: boolean = false;
  titleStateNote: string = '';
  titleWindow: string = 'Captura Notas';
  totalValueInvoice: number = 0;
  typeConcept: number = TypeConceptEnums.notaCredito;
  url: string = '';
  userAuthenticated: UserModel = new UserModel();
  componentAttachFiles = CustomAttachFilesComponent;
  componentTableSelection = CustomTableSelectComponent;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private bussinessDocumentsTypeService: BussinessDocumentsTypeService,
    private confirmDialogService: ConfirmDialogService,
    private dateConverterService: DateConverterService,
    private documentSupportService: DocumentSupportService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private invoiceService: InvoiceService,
    private location: Location,
    private noteService: NoteService,
    private optionWindowService: OptionWindowService,
    private requestNoteService: RequestNoteService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private headerService: HeaderService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService,
    private formatService: FormatService) {
    this.validateForm(this.noteContract);
    this.getPermissionPrint();
  }

  async ngOnInit() {
    await this.getPermission();
    if (this.isDocumentSupport) {
      this.nameWindow = 'Captura Notas Ajuste Documento Soporte';
      this.previousWindow = 'Notas Ajuste Documento Soporte';
      this.iconWindow = 'shopping_cart';
    } else {
      this.nameWindow = 'Captura Notas';
      this.previousWindow = 'Notas';
      this.iconWindow = 'request_quote';
    }
    this.activatedRoute.params.subscribe(params => {
      this.noteId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} -  ${this.projectName}`);
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeRequestNote(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeRequestNote(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
    this.subscriptionAttach = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
    await this.getFormatByCompanyAndCode();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async handleInitialState() {
    if (this.noteId !== null && this.noteId !== 0) {
      this.editNote();
      this.formNote.get("isLevelArticle")?.disable();
      this.formNote.get("invoiceConsecutive")?.disable();
    } else {
      await this.getFirstBranchEnterprise();
      this.createNewNote();
    }
  }

  async annulInvoiceByNote() {
    if (!this.noteContract || !this.noteContract.noteId || this.noteContract.noteId === 0) {
      this.toastHandlerService.showToast('warning', 'Primero debe guardar la nota antes de poder anular.', 'Atención');
      return;
    }

    const result = await Swal.fire({
      title: 'Atención',
      html: this.isDocumentSupport
        ? '¿Realmente desea ANULAR el documento soporte? Luego de anulado no podrá ser modificado.'
        : '¿Realmente desea ANULAR esta factura? Luego de anulada la factura no podrá ser modificada.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        this.noteContract = await firstValueFrom(this.noteService.annulInvoiceByNote(this.noteId));
        this.validateForm(this.noteContract);
      } catch (error) {
        console.error('Error anulando la factura:', error);
      }
    }
  }

  async applyNoteTypeConfig(noteTypeId: number): Promise<void> {
    const typeConfig = {
      [NoteTypeEnums.creditNote]: {
        classId: BussinessDocumentsClassEnums.notaCredito,
        concept: TypeConceptEnums.notaCredito,
        buttonAnnuls: false
      },
      [NoteTypeEnums.debitNote]: {
        classId: BussinessDocumentsClassEnums.notaDebito,
        concept: TypeConceptEnums.notaDebito,
        buttonAnnuls: true
      },
      [NoteTypeEnums.supportDocument]: {
        classId: BussinessDocumentsClassEnums.documSoporte,
        concept: TypeConceptEnums.notaCredito,
        buttonAnnuls: false
      }
    };

    const config = typeConfig[noteTypeId as keyof typeof typeConfig] || {
      classId: BussinessDocumentsClassEnums.documSoporte,
      concept: TypeConceptEnums.notaCredito
    };

    this.noteTypeId = noteTypeId;
    this.typeConcept = config.concept;
    this.bussinessDocumentsClassId = config.classId;
    this.buttonAnnuls = config.buttonAnnuls;

    await this.updateConceptListByNoteType();
  }

  changeEnterprise() {
    const branchId = this.formNote.get("branchId")?.value;
    const noteTypeId = this.formNote.get("noteTypeId")?.value;
    const bussinessDocumentsTypeId = this.formNote.get("bussinessDocumentsTypeId")?.value;
    this.branchId = branchId;
    this.noteTypeId = noteTypeId;
    this.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
    this.resetNoteState();
    this.noteContract = new NoteModel();
    this.noteContract.branchId = branchId;
    this.noteContract.enterpriseId = this.enterpriseId;
    this.noteContract.noteTypeId = noteTypeId;
    this.noteContract.operationTypeDian = this.swElectronicInvoice ? 20 : 0;
    this.validateForm(this.noteContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async changeBussinessDocumentsType() {
    const branchId = this.formNote.get("branchId")?.value;
    const enterpriseId = this.formNote.get("enterpriseId")?.value;
    const noteTypeId = this.formNote.get("noteTypeId")?.value;
    this.branchId = branchId;
    this.enterpriseId = enterpriseId;
    this.noteTypeId = noteTypeId;
    this.resetNoteState();
    this.noteContract = new NoteModel();
    this.noteContract.branchId = branchId;
    this.noteContract.enterpriseId = enterpriseId;
    this.noteContract.noteTypeId = noteTypeId;
    this.noteContract.bussinessDocumentsTypeId = this.bussinessDocumentsTypeId;
    this.noteContract.operationTypeDian = this.swElectronicInvoice ? 20 : 0;
    this.validateForm(this.noteContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    this.noteId = 0;
    this.noteContract = new NoteModel();
    this.noteContract.branchId = branchId;
    this.validateForm(this.noteContract);
    try {
      this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
    } catch (error) {
      console.error('Error al buscar las empresas de la sucursal.', error);
    }
    this.location.replaceState(`/${this.url}/register`);
  }

  async changeNoteType(noteTypeId: number): Promise<void> {
    await this.applyNoteTypeConfig(noteTypeId);
    await this.getFirstBussinessDocumentsType();
    this.changeBussinessDocumentsType();
    this.location.replaceState(`/${this.url}/register`);
  }

  async changeConsecutive() {
    let consecutive = this.formNote.get("consecutive")?.value;
    if (this.noteContract.consecutive == consecutive) return;
    const branchId = this.formNote.get("branchId")?.value;
    const enterpriseId = this.formNote.get("enterpriseId")?.value;
    const noteTypeId = this.formNote.get("noteTypeId")?.value;
    const bussinessDocumentsTypeId = this.formNote.get("bussinessDocumentsTypeId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una empresa.', 'Atención');
      return;
    } else if (noteTypeId == null || noteTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de nota.', 'Atención');
      return;
    } else if (bussinessDocumentsTypeId == null || bussinessDocumentsTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de documento comercial.', 'Atención');
      return;
    } else if (consecutive == 0) {
      consecutive = null;
    }

    if (consecutive == null) {
      this.noteId = 0;
      const modelNote = new NoteModel();
      modelNote.branchId = branchId;
      modelNote.enterpriseId = enterpriseId;
      modelNote.noteTypeId = noteTypeId;
      modelNote.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
      this.noteContract = modelNote;
    } else {
      try {
        this.noteContract = await firstValueFrom(this.noteService.getNoteByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, noteTypeId,
          consecutive, this.isDocumentSupport));
        this.noteId = this.noteContract.noteId;
        this.validateForm(this.noteContract);
        this.location.replaceState(`/${this.url}/register/${this.noteId}`);
      } catch (error) {
        console.error('Error al buscar la nota por llaves:', error);
      }
    }
  }

  async changeStateNote() {
    if (this.noteContract.consecutive == 0) {
      this.toastHandlerService.showToast('warning', 'La nota no está guardada.', 'Atención');
      return;
    }
    if (this.permissionUpdatable) {
      try {
        this.noteContract = await firstValueFrom(this.noteService.setStateNote(this.noteContract.noteId));
        this.validateForm(this.noteContract);
        this.toastHandlerService.showToast('success', 'El estado de la nota se modificó exitosamente.');
      } catch (error) {
        console.error('Error al modificar el estado de la nota:', error);
      }
    } else {
      this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para cambiar estados de notas. Comuníquese con el administrador del sistema.', 'Error');
    }
  }

  changeDocumentSupport(consecutiveDocument: number) {
    const consecutive = consecutiveDocument;
    if (consecutive == null || consecutive == 0 || consecutive == -1) {
      this.getProvider(0);
      this.dateInvoice = '';
      this.totalValueInvoice = 0;
      this.residueValueInvoice = 0;
      return;
    }
    this.documentSupportConsecutive = consecutive;
    this.getDocumentSupportByCode();
  }

  async changeInvoice(consecutiveDocument: number) {
    const consecutive = consecutiveDocument;
    if (consecutive == null || consecutive == 0 || consecutive == -1) {
      this.getCostCenter(new CostCenterModel());
      this.getClient(0);
      this.dateInvoice = '';
      this.totalValueInvoice = 0;
      this.residueValueInvoice = 0;
      return;
    }
    this.invoiceConsecutive = consecutive;
    this.getInvoiceByCode();
  }

  changeLevel(level: any) {
    const currentLevel = this.noteContract.isLevelArticle;
    if (currentLevel !== level) {
      this.noteContract.isLevelArticle = level;
    }
  }

  changeValues() {
    if (this.noteContract.noteId != 0) {
      this.headerChanged = true
    };
    const operationTypeDian = this.formNote.get("operationTypeDian")?.value;
    if (operationTypeDian == 22) {
      this.toastHandlerService.showToast('info', 'Tenga presente que al sincronizar electronicamente una nota sin referencia a facturas. NO se enviara a la DIAN la informacion de factura afectada.', 'Atención');
    }
  }

  clearClientOrProviderData(type: 'client' | 'provider') {
    this.stateClientId = ClientStateEnums.activo;
    if (type === 'client') {
      this.clientId = 0;
      this.codeCurrency = '';
      this.codeNameClient = '';
    } else if (type === 'provider') {
      this.providerId = 0;
      this.codeNameProvider = '';
    }
  }

  async createNewNote() {
    if (this.permissionUpdatable) {
      this.resetNoteState();
      this.notePrintModel = new NotePrintModel();
      this.noteContract = new NoteModel();
      this.noteContract.branchId = this.branchId
      this.noteContract.enterpriseId = this.enterpriseId;
      this.noteContract.noteTypeId = this.noteTypeId;
      this.noteContract.bussinessDocumentsTypeId = this.bussinessDocumentsTypeId;
      this.noteContract.consecutive = 0;
      this.noteContract.operationTypeDian = this.swElectronicInvoice ? 20 : 0;
      await this.validateForm(this.noteContract);
      this.location.replaceState(`/${this.url}/register`);
      if (this.requestNoteActive && !this.isDocumentSupport) {
        this.openSelectRequestNoteModal();
      }
    } else {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear notas. Comuníquese con el administrador del sistema.', 'Atención');
    }
  }

  private configureNoteType(): void {
    if (this.isDocumentSupport) {
      this.formNote.controls["noteTypeId"].patchValue(NoteTypeEnums.supportDocument);
      this.noteTypeId = NoteTypeEnums.supportDocument;
      this.bussinessDocumentsClassId = BussinessDocumentsClassEnums.notaDocumSoporte;
      this.bussinessDocumentsTypeClass = BussinessDocumentsClassEnums.documSoporte;
    } else {
      this.applyNoteTypeConfig(this.noteContract.noteTypeId)
      this.formNote.controls["noteTypeId"].patchValue(this.noteContract.noteTypeId);
    }
  }

  async deleteFile(file: any) {
    if (this.noteContract.noteId != 0) {
      const accepted = await this.confirmDialogService.confirm(`¿Realmente desea eliminar el adjunto seleccionado?`);
      if (accepted) {
        try {
          await firstValueFrom(this.requestNoteService.deleteFilesToRequestNote(this.noteId, file));
          this.toastHandlerService.showToast('success', 'El adjunto fue eliminado exitosamente', '');
          this.getFilesToRequestNote();
        } catch (error) {
          console.error('Error catch:', error);
        }
      }
    }
  }

  async deleteNote() {
    if (this.noteContract.noteId != 0) {
      if (this.permissionUpdatable) {
        const result = await Swal.fire({
          title: 'Atención',
          text: `¿Realmente desea eliminar la nota ${this.noteContract.consecutive}?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No'
        });
        if (result.isConfirmed) {
          try {
            await firstValueFrom(this.noteService.deleteNote(this.noteContract.noteId));
            this.toastHandlerService.showToast('success', 'La nota fue eliminada exitosamente.');
            this.createNewNote();
          } catch (error) {
            console.error('Error al eliminar la nota:', error);
          }
        }
      } else {
        this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para eliminar notas. Comuníquese con el administrador del sistema.', 'Atención');
      }
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la notas.', 'Atención');
    }
  }

  downloadFile(fileName: any) {
    if (this.noteContract.noteId != 0) {
      this.requestNoteService.downloadFileToRequestNote(this.noteId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  async editNote() {
    this.notePrintModel = new NotePrintModel();
    await this.getNoteById();
    this.configureNoteType();
    this.noteId = this.noteContract.noteId;
    this.enterpriseId = this.noteContract.enterpriseId;
    this.bussinessDocumentsTypeId = this.noteContract.bussinessDocumentsTypeId;
    this.validateForm(this.noteContract);
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async generateNote(requestNote: RequestNoteModalModel[]) {
    if (requestNote.length > 0) {
      const noteId = requestNote[0].id;
      const accepted = await this.confirmDialogService.confirm(
        `¿Realmente desea generar la nota desde la solicitud de nota ${requestNote[0].requestConsecutive}?`
      );
      if (accepted) {
        try {
          const response = await firstValueFrom(this.noteService.generateNoteByRequestNoteAsync(noteId));
          this.toastHandlerService.showToast('success', `La nota fue generada exitosamente.`);
          this.noteContract = response;
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/${this.url}/register/${this.noteId}`);
        } catch (error) {
          console.error('Error al generar la nota.', error);
        }
      }
    }
  }

  async getAccountingInterfaceCode(accountingInterfaceId: number | null) {
    if (accountingInterfaceId != null && accountingInterfaceId != 0) {
      this.accountingInterfaceCode = await firstValueFrom(this.noteService.getAccountingInterfaceCode(accountingInterfaceId));
    } else {
      this.accountingInterfaceCode = '';
    }
  }

  async getAllLists() {
    try {
      const [branches, enterprises, noteType, concept] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId)),
        firstValueFrom(this.noteService.getAllNoteTypeForSelectsAsync()),
        firstValueFrom(this.noteService.getAllConceptForSelectAsync(this.typeConcept)),
      ]);
      this.listBranches = branches;
      this.listEnterprises = enterprises;
      this.listNoteTypes = noteType;
      this.listConcepts = concept;
      this.initNoteTypeOptions();
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getBranch(branchId: number | null, reload: boolean): Promise<void> {
    this.branchId = branchId ?? 0;
    this.formNote.controls["branchId"].patchValue(this.branchId);

    if (reload) {
      await this.changeBranch(this.branchId);
      await this.getFirstEnterpriseByBranch(branchId);
    }
  }

  async getClient(clientId: number | null) {
    if (!clientId) {
      this.clearClientOrProviderData('client');
      return;
    }
    try {
      const client = await firstValueFrom(this.noteService.getClientByIdForRegisterNoteAsync(clientId));
      if (client) {
        this.codeNameClient = client.label;
        this.clientId = clientId;
        this.stateClientId = client.clientStateId;
        this.codeCurrency = client.codeCurrency;
      } else {
        this.clearClientOrProviderData('client');
      }
    } catch (error) {
      console.error('Error al obtener el cliente:', error);
      this.clearClientOrProviderData('client');
    }
  }

  async getCostCenter(costCenterModel: CostCenterModel | null) {
    if (costCenterModel != null && costCenterModel.costCenterId != 0) {
      this.codeNameCostCenter = `${costCenterModel.code} - ${costCenterModel.name}`;
      this.costCenterId = costCenterModel.costCenterId;
      this.stateCostCenterId = costCenterModel.constructionSite.constructionSiteStateId;
      this.formNote.controls["ivaTypeId"].patchValue(costCenterModel.ivaTypeId);
      this.formNote.controls["administrationRate"].patchValue(costCenterModel.administrationRate);
      this.formNote.controls["incidentalRate"].patchValue(costCenterModel.incidentalRate);
      this.formNote.controls["utilityRate"].patchValue(costCenterModel.utilityRate);
    } else {
      this.codeNameCostCenter = '';
      this.costCenterId = null;
      this.formNote.controls["ivaTypeId"].patchValue(IvaTypeEnums.pleno);
      this.formNote.controls["administrationRate"].patchValue(0);
      this.formNote.controls["incidentalRate"].patchValue(0);
      this.formNote.controls["utilityRate"].patchValue(0);;
    }
  }

  async getConcept(conceptId: number | null) {
    const conceptIdOld = this.noteContract.conceptId;
    const quantityDetails = this.quantityDetails !== 0;
    if (conceptId) {
      const concept = this.listConcepts.find(x => x.value === conceptId);
      if (concept && conceptId !== conceptIdOld && quantityDetails) {
        const result = await Swal.fire({
          title: 'Atención',
          text: 'La nota tiene detalles asociados. ¿Realmente desea modificar el concepto?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí',
          cancelButtonText: 'No'
        });
        if (result.isConfirmed) {
          this.changeValues();
        } else {
          this.formNote.controls['conceptId'].patchValue(conceptIdOld);
        }
      }
    }
  }

  async getBussinessDocumentsTypeInvoice(bussinessDocumentsTypeInvoiceId: number | null, reload: boolean) {
    await this.getListBussinessDocumentsTypeInvoice();
    if (bussinessDocumentsTypeInvoiceId != null && bussinessDocumentsTypeInvoiceId != 0) {
      const bussinessDocumentsTypeInvoice = this.listBussinessDocumentsTypesInvoice.find(x => x.value == bussinessDocumentsTypeInvoiceId);
      if (bussinessDocumentsTypeInvoice) {
        this.bussinessDocumentsTypeInvoiceForm.patchValue(bussinessDocumentsTypeInvoiceId);
        this.bussinessDocumentsTypeInvoiceId = bussinessDocumentsTypeInvoiceId;
      } else {
        this.bussinessDocumentsTypeInvoiceId = 0;
        return
      }
    }
    if (this.isDocumentSupport) {
      this.changeDocumentSupport(this.formNote.get("invoiceConsecutive")?.value);
    } else {
      this.changeInvoice(this.formNote.get("invoiceConsecutive")?.value);
    }
    if (reload) {
      this.changeValues();
    }
  }

  async getBussinessDocumentsType(bussinessDocumentsTypeId: number | null, reload: boolean) {
    await this.getListBussinessDocumentsType();
    if (bussinessDocumentsTypeId != null && bussinessDocumentsTypeId != 0) {
      const bussinessDocumentsType = this.listBussinessDocumentsTypes.find(x => x.value == bussinessDocumentsTypeId);
      if (bussinessDocumentsType) {
        this.formNote.controls["bussinessDocumentsTypeId"].patchValue(bussinessDocumentsTypeId);
        this.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
      } else {
        this.formNote.controls["bussinessDocumentsTypeId"].patchValue(0);
        return;
      }
    } else {
      this.formNote.controls["bussinessDocumentsTypeId"].patchValue(0);
    }
    if (reload) {
      this.changeBussinessDocumentsType();
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formNote.get("branchId")?.value;
    const enterpriseId = this.formNote.get("enterpriseId")?.value;
    const noteTypeId = this.formNote.get("noteTypeId")?.value;
    const bussinessDocumentsTypeId = this.formNote.get("bussinessDocumentsTypeId")?.value;
    let consecutive = this.formNote.get("consecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una empresa.', 'Atención');
      return;
    } else if (noteTypeId == null || noteTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de nota.', 'Atención');
      return;
    }
    else if (bussinessDocumentsTypeId == null || bussinessDocumentsTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de documento comercial.', 'Atención');
      return;
    } else if (consecutive == 0) {
      consecutive = null;
    }

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.noteContract = await firstValueFrom(this.noteService.getFirstNoteByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, noteTypeId,));
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/${this.url}/register/${this.noteId}`);
        } catch (error) {
          console.error('Error al buscar la primera nota:', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.noteContract = await firstValueFrom(this.noteService.getPreviusNoteByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, noteTypeId,
            consecutive));
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/${this.url}/register/${this.noteId}`);
        } catch (error) {
          console.error('Error al buscar la nota anterior:', error);
        }
        break;
      }
      case 'next': {
        try {
          this.noteContract = await firstValueFrom(this.noteService.getNextNoteByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, noteTypeId,
            consecutive));
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/${this.url}/register/${this.noteId}`);
        } catch (error) {
          console.error('Error al buscar la nota siguiente:', error);
        }
        break;
      }
      case 'last': {
        try {
          this.noteContract = await firstValueFrom(this.noteService.getLastNoteByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, noteTypeId,));
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/${this.url}/register/${this.noteId}`);
        } catch (error) {
          console.error('Error al buscar la ultima nota:', error);
        }
        break;
      }
    }
  }

  async getColumnsRequestNotes() {
    try {
      if (this.headerRequestNotes.length === 0) {
        this.headerRequestNotes = await firstValueFrom(
          this.requestNoteService.getColumnsForRequestNotesAsync()
        );
      }
    } catch (error) {
      console.error('Error al obtener las columnas de las solicitudes de notas.', error);
    }
  }

  async getDocumentSupportByCode() {
    try {
      const response = await firstValueFrom(this.documentSupportService.getDocumentSupportByKeysAsync(this.branchId, this.enterpriseId,
        this.bussinessDocumentsTypeInvoiceId, this.documentSupportConsecutive));
      this.noteContract.documentSupportId = response.documentSupportId;
      this.formNote.controls["ivaTypeId"].patchValue(1);
      this.formNote.controls["noteTypeId"].patchValue(NoteTypeEnums.supportDocument);
      this.formNote.controls["isLevelArticle"].patchValue(true);
      this.formNote.controls["operationTypeDian"].patchValue(20);
      this.costCenterId = null;
      this.getProvider(response.providerId);
      this.dateInvoice = formatDate(response.dateDocument, "yyyy-MM-dd", "en-US");
      this.totalValueInvoice = response.totalValue;
      this.residueValueInvoice = response.residueValue;
    } catch (error) {
      this.getProvider(0);
      this.dateInvoice = '';
      this.totalValueInvoice = 0;
      this.residueValueInvoice = 0;
      this.noteContract.documentSupportId = -1;
      console.error('Error al buscar el documento soporte por codigo:', error);
    }
  }

  async getDocumentSupportById(documentSupportId: number | null) {
    if (documentSupportId != null && documentSupportId != 0) {
      try {
        const response = await firstValueFrom(this.documentSupportService.getDocumentSupportById(documentSupportId));
        this.noteContract.documentSupportId = response.documentSupportId;
        this.invoiceConsecutive = response.consecutive;
        this.formNote.controls["invoiceConsecutive"].patchValue(this.invoiceConsecutive);
        this.clientId = 0;
        this.costCenterId = null;
        this.documentSupportConsecutive = response.consecutive;
        this.dateInvoice = formatDate(response.dateDocument, 'dd/MM/yyyy', 'en-US');
        this.totalValueInvoice = response.totalValue;
        this.residueValueInvoice = response.residueValue;
        this.getProvider(response.providerId);
      } catch (error) {
        this.documentSupportConsecutive = 0;
        this.getCostCenter(new CostCenterModel());
        this.getClient(0);
        this.dateInvoice = '';
        this.totalValueInvoice = 0;
        this.residueValueInvoice = 0;
        console.error('Error al buscar el documento soporte por Id:', error);
      }
    }
  }

  async getElectronicInvoiceInterfaceCode(electronicInvoiceInterfaceId: number | null) {
    if (electronicInvoiceInterfaceId != null && electronicInvoiceInterfaceId != 0) {
      this.electronicInvoiceInterfaceCode = await firstValueFrom(this.noteService.getElectronicInvoiceInterfaceCodeById(electronicInvoiceInterfaceId));
    } else {
      this.electronicInvoiceInterfaceCode = '';
    }
  }

  async getEnterprise(enterpriseId: number | null, reload: boolean) {
    if (enterpriseId != null && enterpriseId != 0) {
      const enterprise = await firstValueFrom(this.enterpriseService.getEnterpriseById(enterpriseId));
      if (enterprise) {
        this.enterpriseId = enterpriseId;
        this.formNote.controls["enterpriseId"].patchValue(this.enterpriseId);
        this.swElectronicInvoice = enterprise.swElectronicInvoice;
        this.copyListOperationsTypeDian = [...this.listOperationsTypeDian];
        if (this.swElectronicInvoice) {
          this.copyListOperationsTypeDian.splice(2, 1);
        } else {
          this.copyListOperationsTypeDian.splice(0, 2);
        }
      } else {
        this.enterpriseId = 0;
        this.formNote.controls["enterpriseId"].patchValue(this.enterpriseId);
        return;
      }
    } else {
      this.enterpriseId = 0;
      this.formNote.controls["enterpriseId"].patchValue(this.enterpriseId);
    }
    if (reload) {
      this.changeEnterprise();
      this.getFirstBussinessDocumentsType();
      this.getFirstBussinessDocumentsTypeInvoice();
    }
  }

  async getFilesToRequestNote() {
    try {
      this.listFiles = await firstValueFrom(this.requestNoteService.getFilesToRequestNote(this.noteId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      this.mainBranchByUser = await firstValueFrom(this.userAuthenticatedService.branchObservable
        .pipe(filter(branch => branch && branch.branchId !== 0)));
      this.companyId = this.mainBranchByUser.companyId;
      this.branchId = this.mainBranchByUser.branchId;
    } catch (error) {
      console.error('Error al obtener la sucursal principal del usuario autenticado:', error);
    }
  }

  async getFirstBranchEnterprise() {
    try {
      await this.getBranch(this.mainBranchByUser.branchId, false);
      await this.getFirstEnterpriseByBranch(this.mainBranchByUser.branchId);
    } catch (error) {
      console.error('Error al buscar la sucursal del usuario autenticado:', error);
    }
  }

  async getFirstEnterpriseByBranch(branchId: number | null): Promise<void> {
    if (branchId != null && branchId !== 0) {
      try {
        const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
        if (response) {
          this.enterpriseId = response.enterpriseId;
          this.configureNoteType();
          await this.getEnterprise(this.enterpriseId, false);
          await this.getFirstBussinessDocumentsType();
          await this.getFirstBussinessDocumentsTypeInvoice();
        } else {
          this.enterpriseId = 0;
        }
      } catch (error) {
        console.error('Error al buscar la primera empresa de la sucursal:', error);
      }
    }
  }

  async getFirstBussinessDocumentsType() {
    try {
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getFirstBussinessDocumentsType(this.bussinessDocumentsClassId,
        this.enterpriseId));
      this.getBussinessDocumentsType(response.bussinessDocumentsTypeId, false);
    } catch (error) {
      this.listBussinessDocumentsTypes = [];
      console.error('Error al obtener el primer tipo de documento comercial:', error);
    }
  }

  async getFirstBussinessDocumentsTypeInvoice() {
    try {
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getFirstBussinessDocumentsType(this.bussinessDocumentsTypeClass,
        this.enterpriseId));
      this.getBussinessDocumentsTypeInvoice(response.bussinessDocumentsTypeId, false);
    } catch (error) {
      this.listBussinessDocumentsTypesInvoice = [];
      console.error('Error al obtener el tipo de documento comercial de la factura:', error);
    }
  }

  async getFormatByCompanyAndCode() {
    try {
      if (this.formatModel.formatId == 0)
        this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.notes));
    } catch (error) {
      console.error('Error al obtener el formato:', error);
    }
  }

  getGeneralParametersByCompany() {
    return new Promise((resolve) => {
      this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
        this.requestNoteActive = response.some(x => x.name === "ActivaSolicitudesDeNotas");
        if (this.requestNoteActive) {
          this.disabledSend = true;
        }
      });
      resolve(true);
    });
  }

  async getListBussinessDocumentsType() {
    try {
      this.listBussinessDocumentsTypes = await firstValueFrom(this.noteService.getAllBussinessDocumentsTypesForSelectAsync(this.bussinessDocumentsClassId, this.branchId, this.enterpriseId));
    } catch (error) {
      this.listBussinessDocumentsTypes = [];
      console.error('Error al obtener el tipo documento por tipo de nota:', error);
    }
  }

  async getListBussinessDocumentsTypeInvoice() {
    try {
      this.listBussinessDocumentsTypesInvoice = await firstValueFrom(this.noteService.getAllBussinessDocumentsTypesInvoiceForSelectAsync(this.isDocumentSupport, this.branchId, this.enterpriseId));
    } catch (error) {
      this.listBussinessDocumentsTypesInvoice = [];
      console.error('Error al obtener el tipo documento por tipo de factura:', error);
    }
  }

  async getInvoiceByCode() {
    try {
      const response = await firstValueFrom(this.invoiceService.getInvoiceByParamsAsync(this.branchId, this.enterpriseId, this.bussinessDocumentsTypeInvoiceId,
        this.invoiceConsecutive));
      this.noteContract.invoiceId = response.invoiceId;
      this.dateInvoice = formatDate(response.dateInvoice, 'dd/MM/yyyy', 'en-US');
      this.totalValueInvoice = response.totalValue;
      this.residueValueInvoice = response.residueValue;
      this.getCostCenter(response.costCenter);
      this.getClient(response.clientId);
    } catch (error) {
      this.getCostCenter(new CostCenterModel());
      this.getClient(0);
      this.dateInvoice = '';
      this.totalValueInvoice = 0;
      this.residueValueInvoice = 0;
      this.noteContract.invoiceId = -1;
      console.error('Error al buscar la factura por codigo:', error);
    }
  }

  async getInvoiceById(invoiceId: number | null) {
    if (invoiceId != null && invoiceId != 0) {
      try {
        const response = await firstValueFrom(this.invoiceService.getInvoiceById(invoiceId));
        this.noteContract.invoiceId = response.invoiceId;
        this.invoiceConsecutive = response.consecutive;
        this.formNote.controls["invoiceConsecutive"].patchValue(this.invoiceConsecutive);
        this.providerId = 0;
        this.dateInvoice = formatDate(response.dateInvoice, 'dd/MM/yyyy', 'en-US');
        this.totalValueInvoice = response.totalValue;
        this.residueValueInvoice = response.residueValue;
        this.getCostCenter(response.costCenter);
        this.getClient(response.clientId);
      } catch (error) {
        this.invoiceConsecutive = 0;
        this.getCostCenter(new CostCenterModel());
        this.getClient(0);
        this.dateInvoice = '';
        this.totalValueInvoice = 0;
        this.residueValueInvoice = 0;
        console.error('Error al buscar la factura por Id:', error);
      }
    }
  }

  async getNoteById() {
    try {
      this.noteContract = await firstValueFrom(this.noteService.getNoteById(this.noteId));
      if (this.branchId != this.noteContract.branchId) {
        this.branchId = this.noteContract.branchId;
        try {
          this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
        } catch (error) {
          console.error('Error al buscar las empresas de la sucursal.', error);
        }
      }
    } catch (error) {
      console.error('Error al buscar la nota:', error);
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    url = url.substring(0, url.indexOf("/"));
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`, 'Atención');
      }
    } else {
      localStorage.clear();
    }
    this.url == 'note' ? this.isDocumentSupport = false : this.isDocumentSupport = true;
    await this.getFirstBranchByUserAuthenticatedAsync();
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
      this.getGeneralParametersByCompany();
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar los permisos del perfil:', error);
    }
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.noteService.getPermissionPrint());
    } catch (error) {
      console.error('Error al obtener los permisos de impresión:', error);
    }
  }

  async getPermissionsForUserByWindow() {
    try {
      this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable
        .pipe(filter(user => user && user.userId !== 0)));
    } catch (error) {
      console.error('Error al obtener el usuario autenticado:', error);
    }
    if (this.isDocumentSupport) {
      try {
        this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.NoteDocumentSupport));
      } catch (error) {
        console.error('Error al obtener permisos para documento soporte:', error);
      }
    } else {
      try {
        this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Note));
      } catch (error) {
        console.error('Error al obtener permisos para nota:', error);
      }
    }
  }

  async getPrintNote(reload: boolean) {
    try {
      this.notePrintModel = await firstValueFrom(this.noteService.printNote(this.noteId, reload));
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
    }
  }

  async getProvider(providerId: number | null): Promise<void> {
    if (!providerId) {
      this.clearClientOrProviderData('provider');
      return;
    }

    try {
      const provider = await firstValueFrom(this.noteService.getProviderByIdForRegisterNoteAsync(providerId));
      if (provider) {
        this.codeNameProvider = provider.label;
        this.providerId = providerId;
        this.stateClientId = provider.providerState;
      } else {
        this.clearClientOrProviderData('provider');
      }
    } catch (error) {
      console.error('Error al obtener el proveedor:', error);
      this.clearClientOrProviderData('provider');
    }
  }

  async getRequestNotesForNote() {
    const branchId = this.formNote.get("branchId")?.value;
    const enterpriseId = this.formNote.get("enterpriseId")?.value;
    const noteTypeId = this.formNote.get("noteTypeId")?.value;
    const bussinessDocumentsTypeId = this.formNote.get("bussinessDocumentsTypeId")?.value;
    try {
      this.dataRequestNotes = await firstValueFrom(
        this.requestNoteService.getRequestNotesForNoteAsync(
          branchId,
          enterpriseId,
          noteTypeId,
          bussinessDocumentsTypeId,
          this.pageRequestNote,
          this.limitRequestNote,
          this.columnSortRequestNote,
          this.ascendantRequestNote,
          this.filtersRequestNotes
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de las solicitudes de notas:', error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate([`/${this.url}`]);
  }

  getUpdateNote(note: NoteModel) {
    this.noteContract = note;
    this.validateForm(this.noteContract);
  }

  initNoteTypeOptions(): void {
    if (this.isDocumentSupport) {
      this.listNoteTypeFiltered = this.listNoteTypes.filter(x => x.value == NoteTypeEnums.supportDocument);
    } else {
      this.listNoteTypeFiltered = this.listNoteTypes.filter(x => x.value == NoteTypeEnums.creditNote || x.value == NoteTypeEnums.debitNote);
    }
  }

  async loadExistingNoteData(): Promise<void> {
    this.noteId = this.noteContract.noteId;
    this.cude = this.noteContract.cude;
    this.formNote.enable();
    const promises = [];

    promises.push(this.getBranch(this.noteContract.branchId, false));
    promises.push(this.getEnterprise(this.noteContract.enterpriseId, false));
    promises.push(this.getBussinessDocumentsType(this.noteContract.bussinessDocumentsTypeId, false));
    promises.push(this.getConcept(this.noteContract.conceptId));
    promises.push(this.getAccountingInterfaceCode(this.noteContract.accountingInterfaceId));
    promises.push(this.getElectronicInvoiceInterfaceCode(this.noteContract.electronicInvoiceInterfaceId));

    if (this.isDocumentSupport) {
      const docSupportPromise = this.getDocumentSupportById(this.noteContract.documentSupportId);
      promises.push(this.getProvider(this.noteContract.providerId));
      promises.push(docSupportPromise);
      promises.push(docSupportPromise.then(() => {
        return this.getBussinessDocumentsTypeInvoice(this.noteContract.documentSupport!.bussinessDocumentsTypeId, false);
      }));
    } else {
      this.invoiceSwSelfRetainer = this.noteContract.invoice?.enterpriseSwSelfRetainer ?? false;
      this.invoiceSwIcaSelfRetainer = this.noteContract.invoice?.enterpriseSwIcaSelfRetainer ?? false;
      const invoicePromise = this.getInvoiceById(this.noteContract.invoiceId);
      promises.push(invoicePromise);
      promises.push(invoicePromise.then(() => {
        return this.getBussinessDocumentsTypeInvoice(this.noteContract.invoice!.bussinessDocumentsTypeId, false);
      })
      );
    }
    await Promise.all(promises);
  }

  async onFilterChangeRequestNote(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersRequestNotes = this.removeDuplicates(filters);
    this.filtersRequestNotes.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChangeRequestNote(event: {
    page: number;
    pageSize: number;
    sortField: string | undefined;
    sortOrder: number;
  }) {
    this.pageRequestNote = event.page;
    this.limitRequestNote = event.pageSize;
    this.columnSortRequestNote = event.sortField || null;
    this.ascendantRequestNote = event.sortOrder === 1;
    this.getRequestNotesForNote();
  }

  onQuantityDetails(quantityDetails: number) {
    this.quantityDetails = quantityDetails;
    if (this.quantityDetails > 0 || this.noteContract.noteStateId != NoteStateEnums.open) {
      setTimeout(() => {
        this.formNote.get("isLevelArticle")?.disable();
        this.formNote.get("invoiceConsecutive")?.disable();
        this.bussinessDocumentsTypeInvoiceForm?.disable();
      }, 100);
    } else {
      setTimeout(() => {
        if (this.isDocumentSupport) this.formNote.get("isLevelArticle")?.disable();
        this.formNote.get("invoiceConsecutive")?.enable();
        this.bussinessDocumentsTypeInvoiceForm?.enable();
      }, 100);
    }
  }

  async openAttachFile() {
    if (this.noteContract.noteId != 0 && this.noteContract.noteId != null) {
      await this.getFilesToRequestNote();
      this.attachFileRequestNoteComponent && this.attachFileRequestNoteComponent.show();
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear una nota.', 'Atención');
    }
  }

  async openSelectRequestNoteModal() {
    this.filtersRequestNotes = [];
    await Promise.all([
      this.getColumnsRequestNotes(),
      this.getRequestNotesForNote(),
    ]);
    this.updateInputs();

    if (this.selectRequestNoteModalComponent && this.headerRequestNotes) {
      this.selectRequestNoteModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'error',
        'No se pudieron cargar las solicitudes de notas. Por favor, inténtelo de nuevo.'
      );
    }
  }

  async printPage() {
    if (!this.noteContract || this.noteContract.noteId === 0) {
      this.toastHandlerService.showToast('warning', `Debe crear el encabezado de la nota.`, 'Atención');
      return;
    }
    if (!this.permissionPrint) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para imprimir notas. Comuníquese con el administrador del sistema.`, 'Atención');
      return;
    }
    if (this.noteContract.enterprise.swElectronicInvoice && this.noteContract.cude == null) {
      this.toastHandlerService.showToast('warning', `No puedo imprimir. La nota no se ha sincronizado electrónicamente.`, 'Atención');
      return;
    }
    //Muestro formato:
    this.printNoteFormat = true;
    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    await this.getPrintNote(true);
    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
    this.noteContract.noteStateId = NoteStateEnums.printed;
    this.validateForm(this.noteContract);
    //Oculto formato:
    this.printNoteFormat = false;
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (
      valueFilter === null ||
      valueFilter === undefined ||
      valueFilter === '' ||
      valueFilter === 0
    ) {
      this.filtersRequestNotes = this.filtersRequestNotes.filter(
        (f) => f.propertyName !== propertyName
      );
    } else {
      const existingFilter = this.filtersRequestNotes.find(
        (f) => f.propertyName === propertyName
      );
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.noteId != 0 && this.noteId != null) {
      this.router.navigate([`/${this.url}/register/`, this.noteId]);
    } else {
      this.router.navigate([`/${this.url}/register/`]);
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  resetNoteState() {
    this.noteId = 0;
    this.accountingInterfaceCode = '';
    this.clientId = 0;
    this.codeCurrency = '';
    this.codeNameClient = '';
    this.codeNameCostCenter = '';
    this.codeNameProvider = '';
    this.cude = '';
    this.dateInvoice = 'dd/mm/aaaa';
    this.documentSupportConsecutive = 0;
    this.electronicInvoiceInterfaceCode = '';
    this.requestNoteConsecutive = '';
    this.invoiceConsecutive = 0;
    this.invoiceSwIcaSelfRetainer = false;
    this.invoiceSwSelfRetainer = false;
    this.providerId = 0;
    this.quantityDetails = 0;
    this.residueValueInvoice = 0;
    this.stateClientId = ClientStateEnums.activo;
    this.stateCostCenterId = ClientStateEnums.activo;
    this.totalValueInvoice = 0;
  }

  async send() {
    if (this.formNote.valid) {
      this.formNote.enable();
      this.formNote.controls["operationTypeDian"].enable();
      const modelNote = this.formNote.value as NoteModel;
      //Hago null, los campos que permiten ser nulos:
      if (modelNote.clientId == 0) modelNote.clientId = null;
      if (modelNote.providerId == 0) modelNote.providerId = null;
      if (modelNote.invoiceId == 0) modelNote.invoiceId = null;
      if (modelNote.documentSupportId == 0) modelNote.documentSupportId = null;
      if (modelNote.costCenterId == 0) modelNote.costCenterId = null;
      if (modelNote.observation == '') modelNote.observation = null;
      if (modelNote.observationPrint == '') modelNote.observationPrint = null;
      if (modelNote.cude == '') modelNote.cude = null;
      if (modelNote.responseAcuse == '') modelNote.responseAcuse = null;
      if (modelNote.responseEmailAcuse == '') modelNote.responseEmailAcuse = null;
      if (modelNote.statusDianCode == '') modelNote.statusDianCode = null;
      if (modelNote.statusDianDescription == '') modelNote.statusDianDescription = null;
      if (modelNote.technologicalProviderMessageCode == '') modelNote.technologicalProviderMessageCode = null;
      if (modelNote.technologicalProviderMessageDescription == '') modelNote.technologicalProviderMessageDescription = null;
      if (modelNote.xmlName == '') modelNote.xmlName = null;
      if (modelNote.clientStatusCode == '') modelNote.clientStatusCode = null;

      if (this.isDocumentSupport) {
        if (this.noteContract.documentSupportId === -1) {
          this.toastHandlerService.showToast('warning', `Debe seleccionar un documento soporte válido.`, 'Atención');
          return;
        }
        modelNote.documentSupportId = this.noteContract.documentSupportId;
        modelNote.providerId = this.providerId;
        modelNote.isDocumentSupport = true;
        modelNote.isLevelArticle = true;
      } else {
        if (this.noteContract.invoiceId === -1) {
          this.toastHandlerService.showToast('warning', `Debe seleccionar una factura válida.`, 'Atención');
          return;
        }
        modelNote.invoiceId = this.noteContract.invoiceId;
        modelNote.clientId = this.clientId;
        modelNote.costCenterId = this.costCenterId == 0 ? null : this.costCenterId;
      }

      if (this.noteId == 0) {
        try {
          const response = await firstValueFrom(this.noteService.createNote(modelNote));
          this.toastHandlerService.showToast('success', `La nota fue creada exitosamente.`);
          this.noteContract = response;
          this.noteId = this.noteContract.noteId;
          this.validateForm(this.noteContract);
          this.location.replaceState(`/${this.url}/register/${this.noteId}`);
          // Abrir automáticamente el formulario de detalle al crear el encabezado
          this.noteDetailComponent?.getFormDetailView(true);
        } catch (error) {
          console.error('Error al crear la nota:', error);
        }
      } else {
        this.noteContract.isLevelArticle = modelNote.isLevelArticle;
        this.noteContract.dateNote = modelNote.dateNote;
        this.noteContract.conceptId = modelNote.conceptId;
        this.noteContract.operationTypeDian = modelNote.operationTypeDian;
        this.noteContract.invoiceId = modelNote.invoiceId;
        this.noteContract.documentSupportId = modelNote.documentSupportId;
        this.noteContract.clientId = modelNote.clientId;
        this.noteContract.costCenterId = modelNote.costCenterId;
        this.noteContract.observationPrint = modelNote.observationPrint;
        this.noteContract.observation = modelNote.observation;
        try {
          const response = await firstValueFrom(this.noteService.updateNote(this.noteContract));
          this.toastHandlerService.showToast('success', `La nota fue modificada exitosamente.`);
          this.noteContract = response;
          this.validateForm(this.noteContract);
        } catch (error) {
          this.validateForm(this.noteContract);
          console.error('Error al actualizar la nota:', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const documentName = this.isDocumentSupport ? 'documento soporte' : 'factura';
    const controlMessages: any = {
      branchId: 'El campo "Sucursal" es obligatorio.',
      enterpriseId: 'El campo "Empresa" es obligatorio.',
      noteTypeId: 'El campo "Tipo de nota" es obligatorio.',
      isLevelArticle: 'El campo "Nivel" es obligatorio.',
      dateNote: 'El campo "Fecha" es obligatorio.',
      conceptId: 'El campo "Concepto" es obligatorio.',
      operationTypeDian: 'El campo "Tipo de operación" es obligatorio.',
      invoiceConsecutive: `El campo "${documentName}" es obligatorio.`,
      observation: 'El campo "Observación" permite un máximo de 250 caracteres.',
    };

    Object.keys(controlMessages).forEach(control => {
      if (this.formNote.controls[control].invalid) {
        this.toastHandlerService.showToast('warning', controlMessages[control], 'Atención');
      }
    });
  }

  async updateConceptListByNoteType() {
    try {
      this.listConcepts = await firstValueFrom(this.noteService.getAllConceptForSelectAsync(this.typeConcept));
    } catch (error) {
      console.error("Error al obtener la lista conceptos:", error);
    }
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.requestNoteService.attachFilesToRequestNote(this.noteId, formData));
      await this.getFilesToRequestNote();
      this.toastHandlerService.showToast('success', 'Se adjunto el archivo exitosamente', '');
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async updateFormState() {
    const stateConfig: any = {
      [NoteStateEnums.open]: {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta'
      },
      [NoteStateEnums.closed]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada'
      },
      [NoteStateEnums.printed]: {
        severity: 'info',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Impresa'
      }
    };

    const currentState = this.noteContract.noteStateId;
    const config = stateConfig[currentState];

    if (config) {
      this.iconStateNote = config.icon;
      this.titleStateNote = config.title;
      this.noteStateString = config.text;
      this.severityState = config.severity;
    }

    if (this.noteContract.noteStateId == NoteStateEnums.open) {
      this.disabledActions = false;
      this.disabledSend = false;
      this.headerChanged = false;

      if (this.noteId != 0) {
        setTimeout(() => this.formNote.controls["consecutive"].enable(), 100);
      } else {
        setTimeout(() => this.formNote.controls["consecutive"].disable(), 100);
      }
      if (this.requestNoteActive && this.noteContract.noteId === 0) {
        this.disabledSend = true;
      }
    } else {
      this.disabledActions = true;
      this.disabledSend = true;
      setTimeout(() => this.formNote.disable(), 100);
      setTimeout(() => this.formControlStateService.setControlState(
        this.formNote, ['branchId', 'enterpriseId', 'noteTypeId', 'bussinessDocumentsTypeId', 'consecutive'], true
      ), 100);
      this.bussinessDocumentsTypeInvoiceForm?.disable();
    }
    setTimeout(() => this.formNoteTotals.disable(), 0);
    if (!this.permissionUpdatable) setTimeout(() => this.formNote.disable(), 100);
    if (this.isDocumentSupport) {
      this.formNote.controls["isLevelArticle"].patchValue(true);
      this.noteContract.isLevelArticle = true;
      setTimeout(() => this.formControlStateService.setControlState(
        this.formNote, ['noteTypeId', 'isLevelArticle'], false
      ), 100);
    }
    if (this.requestNoteActive && !this.isDocumentSupport) {
      setTimeout(() => this.formControlStateService.setControlState(
        this.formNote, ['conceptId', 'observationPrint', 'observation', 'isLevelArticle', 'invoiceConsecutive'], false
      ), 100);
      this.buttonAnnuls = true;
      this.disabledActions = true;
    }
  }

  updateInputs() {
    this.inputsForRequestNoteModal$.next({
      headers: this.headerRequestNotes,
      data: this.dataRequestNotes,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      filters: this.filtersRequestNotes,
    });
  }

  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.noteContract.requestConsecutive,
      disabled: true
    });
  }

  async validateForm(note: NoteModel) {
    this.formNote = this.formBuilder.group({
      branchId: [note.branchId, [Validators.required, Validators.min(1)]],
      enterpriseId: [note.enterpriseId, [Validators.required, Validators.min(1)]],
      noteTypeId: [note.noteTypeId, [Validators.required, Validators.min(1)]],
      bussinessDocumentsTypeId: [note.bussinessDocumentsTypeId, [Validators.required, Validators.min(1)]],
      consecutive: [note.consecutive, [Validators.required]],
      isLevelArticle: [note.isLevelArticle, [Validators.required]],
      dateNote: [note.dateNote ? this.dateConverterService.convertUtcToLocalDate(note.dateNote) : null, [Validators.required]],
      conceptId: [note.conceptId, [Validators.required, Validators.min(1)]],
      operationTypeDian: [note.operationTypeDian, [Validators.required]],
      invoiceId: [note.invoiceId],
      invoiceConsecutive: [note.invoice?.consecutive],
      clientId: [note.clientId],
      documentSupportId: [note.documentSupportId],
      providerId: [note.providerId],
      costCenterId: [note.costCenterId],
      observationPrint: [note.observationPrint, [Validators.maxLength(500)]],
      observation: [note.observation, [Validators.maxLength(500)]],
      ivaTypeId: [note.ivaTypeId, [Validators.required]],
      administrationRate: [note.administrationRate, [Validators.min(0), Validators.max(100)]],
      incidentalRate: [note.incidentalRate, [Validators.min(0), Validators.max(100)]],
      utilityRate: [note.utilityRate, [Validators.min(0), Validators.max(100)]],
      reteIvaRate: [note.reteIvaRate, [Validators.min(0), Validators.max(100)]],
    });
    this.formNoteTotals = this.formBuilder.group({
      subtotalValue: [note.subtotalValue],
      ivaValue: [note.ivaValue],
      totalValue: [note.totalValue],
      reteIvaValue: [note.reteIvaValue],
      reteFuenteValue: [note.reteFuenteValue],
      reteIcaValue: [note.reteIcaValue],
      valueToPay: [note.valueToPay],
    });
    this.requestNoteConsecutive = note.requestConsecutive;
    if (this.noteContract.noteId != 0) {
      await this.loadExistingNoteData();
    }
    this.updateFormState();
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const check = async () => {
        if (this.finishLoadingPrint) {
          print();
          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }

}